import { render, staticRenderFns } from "./StrategicGoalsList.vue?vue&type=template&id=28cca8a3"
import script from "./StrategicGoalsList.vue?vue&type=script&lang=js"
export * from "./StrategicGoalsList.vue?vue&type=script&lang=js"
import style0 from "./StrategicGoalsList.vue?vue&type=style&index=0&id=28cca8a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports